import React, { useState } from 'react';
import { CheckService } from "services/CheckService";
import { AuditingTable } from 'components/auditing';

export function CheckSettingsChangelog() {

    const noDataMessage = "It looks like no previous changes have been made to the check settings.";
    const [tableData, setTableData] = useState(null);
    const [tableRecordCount, setTableRecordCount] = useState(0);

    function onTableChange(pageSize, pageNumber, startDate, endDate) {
        CheckService.getCheckSettingsChangelog(pageSize, pageNumber, startDate, endDate).then(r => {
            setTableData(r.data);
            setTableRecordCount(r.totalCount);
        });
    }

    return (
        <AuditingTable data={tableData} totalCount={tableRecordCount} onChange={onTableChange} noDataMessage={noDataMessage}></AuditingTable>
    );
}